import { createAction, props } from '@ngrx/store';
import { PickupQuery } from '../../models/pickup-query';
import { Pickup } from '../../models/pickup';

export const pickupTableRequest = createAction(
    '[Pickup Table] Load Request'
);

export const pickupTableSuccess = createAction(
    '[Pickup Table] Load Response',
    props<{ totalCount: number, page: Pickup[] }>()
);

export const pickupTableFailure = createAction(
    '[Pickup Table] Load Failure'
);

export const pickupTableChangePage = createAction(
    '[Pickup Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const pickupTableChangeQuery = createAction(
    '[Pickup Table] Change Filter',
    props<{ query: PickupQuery }>()
);

export const pickupTableSort = createAction(
    '[Pickup Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const pickupTableSetSelection = createAction(
    '[Pickup Table] Set Selection',
    props<{ selection: string[] }>()
);

export const pickupTableMasterToggle = createAction(
    '[Pickup Table] Master Selection Toggle'
);

export const pickupTableToggle = createAction(
    '[Pickup Table] Toggle Selection',
    props<{ id: string }>()
);

export const pickupTableAddAssist = createAction(
    '[Pickup Table] Add Filter Assist',
    props<{ id: string, parameter: any }>()
);

export const pickupTableRemoveAssist = createAction(
    '[Pickup Table] Remove Filter Assist',
    props<{ id: string }>()
);
